import React, { useEffect } from 'react';
import Seo from '../components/Seo';

const Contact: React.FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Seo
        title="Contact Dating Agency | Get in Touch with SLAMMMM"
        description="Contact SLAMMMM for dating support, questions, feedback, or help finding meaningful connections. Reach out by phone, email, or social media."
        canonical="https://www.slammmm.com/contact-dating-agency"
      />
      <section className="contact-hero-section">
        <div className="container">
          <div className="row align-items-center g-5">
            <div className="col-lg-7">
              <p className="contact-eyebrow">CONTACT SLAMMMM</p>
              <h1 className="contact-hero-title">Let&apos;s start<br />the <em>conversation.</em></h1>
              <p className="contact-hero-text">Questions about membership, matches, or how it all works? Reach out and a real person from our team will help you find the right way forward.</p>
            </div>
            <div className="col-lg-5">
              <div className="contact-welcome-card">
                <span className="contact-quote">&ldquo;</span>
                <p>Where single ladies and men go to meet, mingle &amp; marry, every question gets answered by a human.</p>
                <div className="contact-stats">
                  <div><strong>&lt;24hr</strong><small>REPLY TIME</small></div>
                  <div><strong>7 days</strong><small>SUPPORT HOURS</small></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="contact-details-section">
        <div className="container">
          <div className="row g-4">
            <div className="col-lg-7">
              <div className="contact-message-card">
                <div className="contact-message-heading"><span>S</span><div><h2>Message the SLAMMMM team</h2><p>Typically replies within a few hours</p></div></div>
                <div className="contact-message-body">
                  <p className="contact-bubble">Hi there. Tell us what&apos;s on your mind and we&apos;ll point you the right way.</p>
                  <p className="mb-0">Send us an email or call directly. We&apos;re happy to help with your account, membership, or questions about meeting someone meaningful.</p>
                  <a href="mailto:slammmm.com@gmail.com" className="btn btn-primary mt-4">Email the team <i className="fa-solid fa-arrow-right ms-2"></i></a>
                </div>
              </div>
            </div>
            <div className="col-lg-5">
              <div className="contact-direct-card">
                <h2>Reach us directly</h2>
                <a href="tel:156519268" className="contact-detail-link"><i className="fa-solid fa-phone"></i><span><small>PHONE</small><strong>15-651-9268</strong></span></a>
                <a href="tel:6102593335" className="contact-detail-link"><i className="fa-solid fa-phone"></i><span><small>PHONE</small><strong>610-259-3335</strong></span></a>
                <a href="mailto:slammmm.com@gmail.com" className="contact-detail-link"><i className="fa-solid fa-envelope"></i><span><small>EMAIL</small><strong>slammmm.com@gmail.com</strong></span></a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default Contact;
